import { BaseService } from "./BaseService";
import { uuidv4 } from "../utils/uuidv4";
import { CognitoUser } from "amazon-cognito-identity-js";
import {
  ScanCheckRequestType,
  FindDuplicatesRequestType,
  ScanFrontCheckResponseType,
  ScanBackCheckResponseType,
  FindDuplicatesResponseType,
  CreateReservationResponseType,
  CreateReservationRequestType,
  SubmitCheckRequestType,
  SubmitCheckResponseType,
} from "../redux/store/check/type";
import { isDeviceVirtual } from "../utils/virtualDevice";
import * as FileSystem from "expo-file-system";

export class MockService extends BaseService {
  constructor(
    public cognitoUser: CognitoUser,
    public dispatch = (tokens: any) => {},
    public url = "https://domuso-dev2.proxy.beeceptor.com"
  ) {
    super(url, cognitoUser, dispatch);
  }

  async getProperties() {
    const url = `property`;
    return this.makeGetRequest(url, false);
  }

  async scanFrontCheck(fileBody: string): Promise<ScanFrontCheckResponseType> {
    const url = `v1/check_scan/scan/front`;
    const fileName = "front.jpg";
    const data: ScanCheckRequestType = {
      request_id: uuidv4(),
      file_name: fileName,
      file_body: isDeviceVirtual() ? fileName : fileBody,
      type: "image/jpeg",
      temp_id: undefined,
    };

    return this.makePostRequest(url, data, true);
  }

  async scanBackCheck({
    uri,
    tempId,
    accountNumber,
    routingNumber,
    propertyName,
  }: Record<string, string>): Promise<ScanBackCheckResponseType> {
    const url = `v1/check_scan/scan/back`;
    const fileName = "back.jpg";
    const data: ScanCheckRequestType = {
      request_id: uuidv4(),
      file_name: fileName,
      file_body: fileName,
      temp_id: tempId,
      account_number: accountNumber,
      routing_number: routingNumber,
      property_name: propertyName,
      type: "image/jpeg",
    };
    return this.makePostRequest(url, data, true);
  }

  async findDuplicates(
    check_number: string,
    check_type: string,
    account_number: string,
    routing_number: string
  ): Promise<FindDuplicatesResponseType> {
    const url = `v1/check_scan/duplicates`;
    const data: FindDuplicatesRequestType = {
      request_id: uuidv4(),
      check_number,
      check_type,
      account_number,
      routing_number,
    };
    // console.log(data);
    return this.makePostRequest(url, data, true);
  }

  async createReservation(
    first_name: string,
    last_name: string,
    prop_id: number
  ): Promise<CreateReservationResponseType> {
    const url = `reservation/create`;
    const data: CreateReservationRequestType = {
      first_name: first_name,
      last_name: last_name,
      prop_id: prop_id,
    };
    return this.makePostRequest(url, data, false);
  }

  async submitCheck(request: SubmitCheckRequestType): Promise<SubmitCheckResponseType> {
    const url = `/v1/check_scan/payment`;
    return this.makePostRequest(url, request, false);
  }

  async getAppReviewData() {
    const url = `v1/app_review`;
    return this.makeGetRequest(url, false);
  }

  async submitAppReviewData(body: any) {
    const url = `v1/app_review`;
    return this.makePostRequest(url, body, false);
  }
}
